import { Button } from "semantic-ui-react"
import { AuthStdFooter } from "../utils/auth-std-footer"

export default function Home() {

  const comingSoon = () => {
    return (
      <>
        <div className="std-pg-main-area" style={{ backgroundColor: "#000000" }} >
          <div className="comingSoonContainer" >
            <div style={{ position: "relative", width: "480px", height: "600px" }}>
              <span className="comingPrompt" >Coming</span>
              <span className="soonPrompt" >Soon!</span>
              <div className="subTitlePromptContainer">
                <div className="subTitlePromptTextContainer">
                  <span className="subTitlePromptText"> Help for Author Narrations...</span>
                </div>
              </div>
            </div>
            <div className="subTitleLearnMoreBtnContainer" >
              <Button className="subTitleLearnMoreBtn" basic color='yellow' size="large" >Learn More</Button>
            </div>
          </div>
        </div >
        {AuthStdFooter()}
      </>
    )
  }

  return (<>{comingSoon()}</>)
} 